<div class="covid__message" *ngIf="configService?.config?.isCovidNoticeEnabled">
  <app-content-module>
    <article class="container">
      <h4>Important updates on recycle and installation during COVID-19</h4>
      <p>
        Some suppliers are not offering these services. If your supplier does
        offer installation, it can be added to your replacement order. A charge
        may apply. If your supplier offers recycle or disposal, you'll need to
        have your old appliance ready for collection - either by your front door
        or outside the front of your home. For more information visit our
        <a
          href="https://www.domesticandgeneral.com/content/help-advice-section/faq/coronavirus-covid19-update"
          target="_blank"
          class="link link--primary"
          >Covid-19 FAQs</a
        >.
      </p>
    </article></app-content-module
  >
</div>
